import { forwardRef } from 'react'
import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'

type TDraggableRow = {
  countAdditionalRows: number
  displayText: string
  getHeightElement: () => string | number
}
export const DraggableRowImage = forwardRef(
  ({ countAdditionalRows, displayText, getHeightElement }: TDraggableRow, outerRef) => {
    const theme = useTheme()
    const height = getHeightElement()

    return (
      <Box
        ref={outerRef}
        sx={{
          width: '300px',
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          borderRadius: '4px',
          fontSize: '14px',
          height: `${height}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 12px',
          boxSizing: 'border-box',
          position: 'relative',

          '&::after': {
            content: `'+${countAdditionalRows}'`,
            position: 'absolute',
            top: 0,
            right: '-8px',
            width: '25px',
            height: `${height}px`,
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '10px',
            fontWeight: 'bold',
            borderLeft: '2px solid white',
            borderRadius: '0 4px 4px 0',
            zIndex: 10,
            visibility: countAdditionalRows ? 'visible' : 'hidden',
          },
        }}
      >
        {displayText}
      </Box>
    )
  }
)

DraggableRowImage.displayName = 'DraggableRowImage'
